module.exports = __webpack_public_path__ + "static/media/windows10.99b8af48.png";